module.exports = __webpack_public_path__ + "static/bentonsans-medium-webfont-882e206f664da3d958a4d8d81cc67158.woff";